var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIllustration = function SvgIllustration(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 130,
    viewBox: "0 0 122 130",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1193 101C81.2679 101 100.035 81.5602 100.035 57.496C100.035 33.4317 81.1852 13.9919 58.1193 13.9919C34.9708 13.9919 16.204 33.4317 16.204 57.496C16.204 81.5602 34.9708 101 58.1193 101Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3065 28.9786C99.1785 28.9786 100.696 27.4066 100.696 25.4675C100.696 23.5283 99.1785 21.9563 97.3065 21.9563C95.4344 21.9563 93.9169 23.5283 93.9169 25.4675C93.9169 27.4066 95.4344 28.9786 97.3065 28.9786Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.267 15.2764C103.545 15.2764 104.582 14.2029 104.582 12.8786C104.582 11.5543 103.545 10.4807 102.267 10.4807C100.988 10.4807 99.952 11.5543 99.952 12.8786C99.952 14.2029 100.988 15.2764 102.267 15.2764Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4361 28.8929C19.7146 28.8929 20.751 27.8193 20.751 26.495C20.751 25.1707 19.7146 24.0972 18.4361 24.0972C17.1577 24.0972 16.1213 25.1707 16.1213 26.495C16.1213 27.8193 17.1577 28.8929 18.4361 28.8929Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29901 75.1373C6.67329 75.1373 8.59802 73.1435 8.59802 70.6841C8.59802 68.2247 6.67329 66.231 4.29901 66.231C1.92473 66.231 0 68.2247 0 70.6841C0 73.1435 1.92473 75.1373 4.29901 75.1373Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122 43.837H117.898V39.5884H114.383V43.837H110.281V47.6001H114.383V51.8487H117.898V47.6001H122V43.837Z",
    fill: "url(#paint0_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1247 3.63195H50.6185V0H47.6131V3.63195H44.1069V6.84881H47.6131V10.4808H50.6185V6.84881H54.1247V3.63195Z",
    fill: "url(#paint1_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8581 39.8668H9.86245V36.7637H7.29471V39.8668H4.29901V42.6153H7.29471V45.7184H9.86245V42.6153H12.8581V39.8668Z",
    fill: "url(#paint2_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.6041 49.1064L79.3256 28.1666C77.8496 24.444 73.9991 22.3168 70.2129 23.1809L48.8428 27.9672C47.0459 28.366 45.5058 29.6291 44.6073 31.2909L24.2641 71.4422C23.4298 73.104 24.0074 75.2313 25.6759 76.0954L62.5119 96.171C64.1163 97.0352 66.1699 96.437 67.0041 94.7086L87.3474 54.5574C88.2458 52.8955 88.31 50.9012 87.6041 49.1064ZM67.1325 40.664C64.5014 39.268 63.4746 35.8778 64.8864 33.1523C66.2341 30.4268 69.5069 29.3632 72.1381 30.8256C74.7692 32.2216 75.796 35.6119 74.3842 38.3373C73.0365 41.0628 69.7636 42.1265 67.1325 40.664Z",
    fill: "url(#paint3_linear)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7636 35.5453C86.5131 26.5711 93.123 13.2095 84.3953 7.42617C75.6676 1.6428 67.0683 7.42617 64.8864 24.2445",
    stroke: "#ADB6C8",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3924 64.5149C66.5255 65.1647 68.0344 64.7155 68.6616 63.5418C69.2889 62.3681 68.8553 60.8051 67.7222 60.1554C66.5891 59.5057 65.0803 59.9548 64.453 61.1285C63.781 62.3861 64.1784 63.8188 65.3924 64.5149Z",
    fill: "#AAB2C5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9354 67.5814L57.8833 66.9781C58.0683 64.4555 56.1244 62.3551 53.7252 62.2937C52.8176 62.2113 51.8117 62.5108 51.0847 63.0796L50.0326 62.4763C52.3118 60.3879 55.9423 60.7172 57.8327 63.1156C58.697 64.2684 59.2115 65.8777 58.9354 67.5814Z",
    fill: "#AAB2C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2055 55.2329C50.3386 55.8827 51.8474 55.4336 52.4747 54.2598C53.1019 53.0861 52.6684 51.5232 51.5353 50.8734C50.4022 50.2237 48.8933 50.6728 48.2661 51.8465C47.675 53.1505 48.0724 54.5832 49.2055 55.2329Z",
    fill: "#AAB2C5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1.88562,
    y: 11.9893,
    width: 108.198,
    height: 117.574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 116.142,
    y1: 40.0143,
    x2: 116.142,
    y2: 46.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 49.1166,
    y1: 0.364089,
    x2: 49.1166,
    y2: 6.24683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 8.57926,
    y1: 37.0747,
    x2: 8.57926,
    y2: 42.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 55.9636,
    y1: 21.2874,
    x2: 55.9636,
    y2: 97.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illustration.baf366f3.svg";
export { ForwardRef as ReactComponent };